// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__2sCtX"};